module.exports = __webpack_public_path__ + "img/zuckerberg-turquoise.f1114e92.png";